import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

export interface ChannelShareData {
    RouterCallKey?: string;
    RouterCallDay?: string;
    ACCOUNT_TYPE?: string;
    ACCOUNT_CATEGORY?: string;
    VALIDATION_FLAG?: string;
    ANI?: string;
    ClientCode?: string;
    MDN?: string;
    COUNTRY_CODE?: string;
    PROTECTED_SALES?: "0" | "1";
    LANGUAGE?: string;
    PARTNER?: string;
    mdn?: string;
    callerId?: string;
    CLIENT?: string;

    INTENT?: string;
    SUMMARY?: string;
    CONVERSATIONAL_SUMMARY?: string;
    CUSTOMER_NAME?: string;
    ORDER_NUMBER?: string;
    PRODUCT_LINK?: string;
    PRODUCT_TITLE?: string;
    BRAND_PHONE_NUMBER?: string;
    SUPPORT_PHONE_NUMBER?: string;

    ACCOUNT_ID?: string;
}

interface CallDetailsState {
    callDetails: ChannelShareData;
    setCallDetails: (callDetails: ChannelShareData) => void;
    resetCallDetails: () => void;
}

export const useCallDetailsStore = createWithEqualityFn<CallDetailsState>()(
    persist(
        immer((set) => ({
            callDetails: {},
            setCallDetails: (callDetails: ChannelShareData) => {
                set((state) => {
                    state.callDetails = callDetails;
                });
            },
            resetCallDetails: () => {
                set((state) => {
                    state.callDetails = {};
                });
            },
        })),
        { name: "call-details-store", skipHydration: true },
    ),
    shallow,
);
